import theme from '@styles/theme';
export default {
  container: {
    position: ['unset', 'unset', 'unset', 'unset', 'relative'],
    width: '100%',
    height: ['auto', 'auto', 'auto', 'auto', '100%'],
    minHeight: ['unset', 'unset', 'unset', 'unset', '800px'],
    p: ['16px 16px 0 16px', '16px 16px 0 16px', '24px 24px 0 24px', '24px 24px 0 24px', '40px 20px 40px 40px']
  },
  searchInputContainer: {
    position: 'relative',
    width: '100%',
    height: '50px',
    marginBottom: '16px',
    p: [0, 0, 0, 0, '0px 20px 0px 0px'],
    input: {
      background: 'transparent',
      width: '100%',
      height: '49px',
      padding: '12px 55px 12px 45px',
      borderRadius: 0,
      border: 0,
      borderBottom: '1px solid',
      borderColor: theme.rawColors.darkGrey700,
      textAlign: 'start',
      fontFamily: theme.fonts.uniform,
      fontWeight: 'normal',
      fontSize: theme.fontSizes.text,
      letterSpacing: theme.letterSpacings.caps,
      '&::placeholder': {
        color: theme.rawColors.darkGrey500
      }
    }
  },
  searchIconContainer: {
    position: 'absolute',
    left: '15px',
    top: '50%',
    height: '20px',
    transform: 'translateY(-50%)',
    zIndex: theme.zIndex.documentUp
  },
  navigationButtonContainer: {
    position: 'absolute',
    right: ['16px', '16px', '16px', '16px', '32px'],
    top: '50%',
    height: '20px',
    transform: 'translateY(-50%)',
    zIndex: theme.zIndex.documentUp
  },
  infoContainer: {
    width: '100%',
    height: ['16px', '16px', '24px', '24px', '32px'],
    fontFamily: theme.fonts.uniform,
    fontSizes: theme.fontSizes.caption,
    fontWeights: theme.fontWeights.normal,
    color: theme.rawColors.darkGrey500,
    padding: ['0 48px 0 12px', '0 48px 0 12px', '0 54px 0 12px', '0 70px 0 16px'],
    zIndex: 0
  },
  bookmarks: {
    display: ['unset', 'unset', 'unset', 'unset', 'none']
  },
  logoBarContainer: {
    position: 'absolute',
    right: 0,
    bottom: ['0', '0', '0', '0', '0'],
    height: ['115px', '115px', '115px', '125px', '145px'],
    width: '100%',
    p: ['24px 0 24px 24px', '24px 0 24px 24px', '24px 0 24px 24px', '24px 0 24px 24px', '20px 0 40px 64px'],
    bottomLinkContainer: {
      fontSizes: theme.fontSizes.smallText,
      width: '100%',
      height: 20,
      mb: ['14px', '14px', '14px', '14px', '32px'],
      pl: [0, 0, 0, 0],
      textDecoration: 'underline'
    }
  },
  autocomplete: {
    '.pac-container': {
      color: theme.rawColors.darkGrey700
    },
    '.pac-icon': {
      display: 'none'
    },
    '.pac-item': {
      fontSize: '12px',
      color: theme.rawColors.darkGrey700
    }
  }
};